import axioslib, { AxiosInstance, AxiosRequestConfig } from "axios";
import { AuthInterceptor } from "./AuthInterceptor";
import VersionInterceptor from "@/api/VersionInterceptor";
import { IMaterial, ICategory } from "@iloq/shared";
import { Logger } from "@iloq/shared";

export default class MaterialApi {
  private readonly axios: AxiosInstance;

  constructor() {
    this.axios = axioslib.create();
    AuthInterceptor.setAuthInterceptors(this.axios);
    VersionInterceptor.setVersionInterceptor(this.axios);
  }

  fetchMaterial(): Promise<IMaterial[]> {
    const options: AxiosRequestConfig = {
      method: "GET",
      url: "/api/v1/material/material", // Supports languageCode as query parameter if needed
    };
    return this.axios(options).then((result) => {
      if (result.status !== 200) {
        Logger.error("MaterialApi.fetchMaterial failed:", result);
        throw new Error(`material (list) ${options.url} - ${result.statusText}`);
      }
      return result.data as IMaterial[];
    });
  }

  getCategories(): Promise<ICategory> {
    const options: AxiosRequestConfig = {
      method: "GET",
      url: "/api/v1/material/categories",
    };
    return this.axios(options).then((result) => {
      if (result.status !== 200) {
        Logger.error("MaterialApi.getCategories failed:", result);
        throw new Error(`categories ${options.url} - ${result.statusText}`);
      }
      return result.data as ICategory;
    });
  }
}
